import { lazy } from 'react';

import CustomLazyLoader from 'routes/CustomLazyLoader';

export const Home = lazy(() => CustomLazyLoader(
  () => import('modules/home/containers/Home'), 'Home',
)); 
